import React          from 'react'
import PropTypes      from 'prop-types'
import { Alert      } from 'react-bootstrap'
import { Link       } from 'react-router-dom'
import { withRouter } from 'react-router'

import { Panel, HorizontalForm, Keyboard } from 'alto-react-components/lib/components'
import { TerminalLoginService            } from 'alto-react-canteen/lib/services'
import { webLogin                        } from 'alto-react-canteen/lib/routes'

class TerminalLogin extends React.Component
  @contextTypes = { auth: PropTypes.object, settings: PropTypes.object }

  constructor: (props, context) ->
    super(props, context)

    @state =
      cardNumber: ''
      errors: null

  render: ->
    <div>
      <Panel className="auth-panel" id="terminal-login-panel" header="Přihlášení" bsStyle="info">
        {@alert()}
        {@form()}
      </Panel>

      <Alert className="auth-alert">
        <Link to={{ pathname: webLogin, state: { terminal: true } }}>
          Přihlásit se jménem a heslem
        </Link>
      </Alert>

      <Keyboard
       value={@state.cardNumber}
       onChange={(value) => @setState(cardNumber: value)}
       onAccepted={=> @submit() if @isValid()} />
    </div>

  alert: ->
    if @state.errors
      <Alert id="login-alert" bsStyle="danger">{@state.errors.message or @state.errors}</Alert>

  form: ->
    error = @state.errors?.card_number

    <HorizontalForm>
      <HorizontalForm.Control controlId='card-number-input' type='text' autoFocus
       label='Číslo karty'
       placeholder='Přiložte kartu'
       value={@state.cardNumber}
       valid={not error} help={error}
       onChange={(value) => @setState(cardNumber: value)}
       onKeyPress={(event) => @submit() if @isValid() and event.key == 'Enter'} />

      <HorizontalForm.Button id='submit-card-number' caption='Pokračovat' bsStyle="primary"
       onClick={@submit} disabled={!@isValid()} />
    </HorizontalForm>

  submit: =>
    service = new TerminalLoginService(@context.auth, @context.settings, @props.history)
    service.perform(@state.cardNumber)
      .then => @context.auth.isTerminal = true
      .catch TerminalLoginService.Failed, (error) => @setState(cardNumber: '', errors: error.data)

  isValid: ->
    @state.cardNumber.length

export default TerminalLogin = withRouter(TerminalLogin)
